const orders = [
  {
    id: "ORD-2411-0142",
    projectTitle: "EV Battery Enclosure v2",
    centre: "APIC Visakhapatnam",
    orderedOn: "Nov 11, 2026",
    amount: 63200,
    paymentStatus: "Paid",
    deliveryStatus: "In Production",
    deliveryColor: "bg-blue-100 text-blue-700",
    trackingId: "APIC-TRK-88214",
    eta: "Nov 28, 2026",
  },
  {
    id: "ORD-2411-0138",
    projectTitle: "Agri Drone Chassis",
    centre: "APIC Vijayawada",
    orderedOn: "Nov 13, 2026",
    amount: 48750,
    paymentStatus: "Paid",
    deliveryStatus: "Quality Inspection",
    deliveryColor: "bg-cyan-100 text-cyan-700",
    trackingId: "APIC-TRK-88231",
    eta: "Nov 22, 2026",
  },
  {
    id: "ORD-2410-0098",
    projectTitle: "Smart Helmet Shell",
    centre: "APIC Kurnool",
    orderedOn: "Oct 01, 2026",
    amount: 19800,
    paymentStatus: "Paid",
    deliveryStatus: "Delivered",
    deliveryColor: "bg-green-100 text-green-700",
    trackingId: "APIC-TRK-87560",
    eta: "Delivered Oct 18, 2026",
  },
  {
    id: "ORD-2410-0083",
    projectTitle: "Solar Charge Controller Case",
    centre: "APIC Vijayawada",
    orderedOn: "Sep 20, 2026",
    amount: 15200,
    paymentStatus: "Paid",
    deliveryStatus: "Delivered",
    deliveryColor: "bg-green-100 text-green-700",
    trackingId: "APIC-TRK-87102",
    eta: "Delivered Oct 05, 2026",
  },
  {
    id: "ORD-2411-0129",
    projectTitle: "IoT Smart Water Sensor",
    centre: "APIC Tirupati",
    orderedOn: "—",
    amount: 21400,
    paymentStatus: "Payment Pending",
    deliveryStatus: "Awaiting Payment",
    deliveryColor: "bg-orange-100 text-orange-700",
    trackingId: "—",
    eta: "—",
  },
];

export default orders;